import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=631ab6e6&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=js&"
export * from "./Score.vue?vue&type=script&lang=js&"
import style0 from "./Score.vue?vue&type=style&index=0&id=631ab6e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ab6e6",
  null
  
)

export default component.exports